import styled from 'styled-components';
import {
  FontSizes,
  TextBody,
} from '../../../common/typography/typography.styles';
import { BaseMarginComponent } from '../../../common/base-margin/base-margin.component';
import { ServicesSubSectionContainer } from '../../services/services-subsection/services-subsection.styles';
import { CheckboxWrapper } from '../../../common/checkbox/checkbox.styles';

export const MarginContainer = styled(BaseMarginComponent('div'))``;

export const TextValue = styled(TextBody)`
  color: ${({ theme }) => theme.colors.baseColors.grey100};
  font-size: ${FontSizes.small};
`;

export const SummaryCheckboxesSection = styled(ServicesSubSectionContainer)`
  form {
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
  }

  ${CheckboxWrapper} {
    margin-bottom: 0;
  }
`;
